import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { makeFichaAvisoURL } from '@navent-jobs/interlinking'

// ui-kit
import { Modal } from '@navent-jobs/ui-kit/components/modal'
import { Row, Col } from '@navent-jobs/ui-kit/components/grid'

// mixins
import {
  Paragraph,
  CustomButton,
  Title,
  ModalBodyComponent,
  ModalBodyContainer,
  TitleAvisosRecomendados,
  AvisoRecomendado,
  ModalFooterContainer,
  ModalFooterComponent,
} from './mixins'

const CONFIDENCIAL = 'Confidencial'
const LIMIT_JOBS = 6

const ModalFooter = ({ closeModal }) => {
  const { t } = useTranslation()

  return (
    <ModalFooterComponent>
      <Row>
        <Col>
          <ModalFooterContainer>
            <Paragraph>{t('¡Mucha suerte en el proceso de selección!')}</Paragraph>
            <CustomButton
              buttonoptions={{ variant: 'primary', size: 'medium', type: 'fill', block: true }}
              onClick={closeModal}
            >
              {t('¡Listo!')}
            </CustomButton>
          </ModalFooterContainer>
        </Col>
      </Row>
    </ModalFooterComponent>
  )
}
const onClickAviso = (event, url) => {
  if (!(event.ctrlKey || event.metaKey)) {
    event.preventDefault()
    window.open(url, '_blank')
  }
}

const ModalBody = ({ avisos }) => {
  const { t } = useTranslation()

  if (!avisos || avisos.length === 0) {
    return null
  }

  return (
    <ModalBodyComponent>
      <ModalBodyContainer>
        <TitleAvisosRecomendados>{`${t('Otros avisos que pueden interesarte')}:`}</TitleAvisosRecomendados>

        {avisos &&
          avisos.length > 0 &&
          avisos.map((aviso, index) => {
            return (
              <AvisoRecomendado
                key="aviso"
                onClick={({ event }) =>
                  onClickAviso(
                    event,
                    makeFichaAvisoURL({
                      ...aviso,
                      empresa: { denominacion: aviso.empresa, confidencial: aviso.empresa === CONFIDENCIAL },
                    })
                  )
                }
                aviso={aviso}
                index={index}
                ubicacion="Avisos recomendados"
              />
            )
          })}
      </ModalBodyContainer>
    </ModalBodyComponent>
  )
}

const ModalPostulacionExitosa = ({ closeModal, visible, fichaAvisoService, idAviso, width }) => {
  const { t } = useTranslation()

  const [avisosPostPostulacion, setAvisosPostPostulacion] = useState([])

  useEffect(() => {
    if (visible) {
      fichaAvisoService.getAvisosPostPostulacion(idAviso, LIMIT_JOBS).then(response => {
        setAvisosPostPostulacion(response)
      })
    }
  }, [visible])

  return (
    <Modal
      width={width}
      visible={visible}
      onClose={closeModal}
      title={<Title>{t('Te postulaste con éxito')}</Title>}
      footer={<ModalFooter closeModal={closeModal} />}
    >
      <ModalBody avisos={avisosPostPostulacion} />
    </Modal>
  )
}

export default ModalPostulacionExitosa
